import {Injectable} from '@angular/core';
import * as aes from 'aes-js';
import * as pkcs7 from 'pkcs7';

const AES_METHOD = 'aes-256-cbc';
const IV_LENGTH = 16; // For AES, this is always 16, checked with php


@Injectable({
  providedIn: 'root'
})
export class OrabankSdkService {
  merchantId: any;
  merchantKey: null;
  iv: any;
  collaboratorId: any;
  url: any;
  blockExistenceIndicator: any;
  payModeTypeCard: any;
  transactionDataBlock: boolean;
  billingDataBlock: boolean;
  shippingDataBlock: boolean;
  paymentDataBlock: boolean;
  merchantDataBlock: boolean;
  otherDataBlock: boolean;
  DCCDataBlock: boolean;
  merchantOrderNumber: string;
  amount: string;
  successUrl: string;
  failureUrl: string;
  transactionMode: string;
  payModeType: string;
  transactionType: string;
  currency: string;
  billToFirstName: string;
  billToLastName: string;
  billToStreet1: string;
  billToStreet2: string;
  billToCity: string;
  billToState: string;
  billtoPostalCode: string;
  billToCountry: string;
  billToEmail: string;
  billToMobileNumber: string;
  billToPhoneNumber1: string;
  billToPhoneNumber2: string;
  billToPhoneNumber3: string;
  shipToFirstName: string;
  shipToLastName: string;
  shipToStreet1: string;
  shipToStreet2: string;
  shipToCity: string;
  shipToState: string;
  shipToPostalCode: string;
  shipToCountry: string;
  shipToPhoneNumber1: string;
  shipToPhoneNumber2: string;
  shipToPhoneNumber3: string;
  shipToMobileNumber: string;
  payModeTypeNetBank: string[];
  cardNumber: string;
  expMonth: string;
  expYear: string;
  CVV: string;
  cardHolderName: string;
  cardType: string;
  custMobileNumber: string;
  paymentID: string;
  OTP: string;
  gatewayID: string;
  cardToken: string;
  UDF1: string;
  UDF2: string;
  UDF3: string;
  UDF4: string;
  UDF5: string;
  UDF6: string;
  UDF7: string;
  UDF8: string;
  UDF9: string;
  UDF10: string;
  custID: string;
  transactionSource: string;
  productInfo: string;
  isUserLoggedIn: string;
  itemTotal: string;
  itemCategory: string;
  ignoreValidationResult: string;
  DCCReferenceNumber: string;
  foreignAmount: string;
  ForeignCurrency: string;
  path: string;
  transactionArray: any;
  billingArray: any;
  shippingArray: any;
  paymentArray: any;
  merchantArray: any;
  otherDataArray: any;
  DCCArray: any;
  TransactionFieldExistenceIndicator: string;
  TransactionData: string;
  TransactionDataBlock1: string;
  BillingFieldExistenceIndicator: string;
  BillingData: string;
  BillingDataBlock2: string;
  ShippingFieldExistenceIndicator: string;
  ShippingData: any;
  ShippingDataBlock3: string;
  PaymentFieldExistenceIndicator: string;
  PaymentData: string;
  PaymentDataBlock4: string;
  MerchantFieldExistenceIndicator: string;
  MerchantData: any;
  MerchantDataBlock5: string;
  OtherDetailsFieldExistenceIndicator: string;
  OtherDetailsData: string;
  OtherDetailsDataBlock6: string;
  DCCFieldExistenceIndicator: string;
  DCCData: string;
  DCCDataBlock7: string;
  DataBlocksArray: { DataBlockBitmap: any; DataBlock1: string; DataBlock2: string; DataBlock3: string; DataBlock4: string; DataBlock5: string; DataBlock6: string; DataBlock7: string; };
  beforeEncryptionString: string;
  EncryptedString: string;
  NeoPostData: string;

  constructor() {
  }

  initProcess(args) {
    // Define Encryption details
    // this.encryptMethod =  MCRYPT_RIJNDAEL_128;
    // this.encryptMode   =  MCRYPT_MODE_CBC;

    // Define the property values
    this.merchantId = null;
    this.merchantKey = null;
    this.iv = null;
    this.collaboratorId = null;
    this.url = null;
    this.blockExistenceIndicator = null;

    this.payModeTypeCard = null;

    // Define the Block Existence Indicator for Bitmap

    this.transactionDataBlock = true;  // Transaction Data Block  ==> This is mandatory block  , 1
    this.billingDataBlock = false; // Billing Data Block      ==> This is an optional block ,0
    this.shippingDataBlock = false; // Shipping Data Block     ==> This is an optional block ,0
    this.paymentDataBlock = false; // Payment Data Block      ==> This is mandatory block , 1 if you are using Merchant hosted Payment , else 0
    this.merchantDataBlock = false; // Merchant Data Block     ==> This is an optional block ,0
    this.otherDataBlock = false; // Other Details Data Block==> This is an optional block ,0
    this.DCCDataBlock = false; // DCC Data Block          ==> This is an optional block ,0

    // Total Seven blocks so the Block Existence Indicator Bitmap will be : 1001000
    // If you are selecting the Billing Data Block the Bitmap indicator will be : 1101000
    // If you are selecting the Shipping Data Block the Bitmap indicator will be :1111000

    // Define the Field Existence Indicator for the Transaction Data Block , All the fields are mandatory *
    this.merchantOrderNumber = ''; // Merchant Order Number :  Unique identifier of the merchant , Like order id , cart id , pay id etc.. As of now we are passing unique timestamp
    this.amount = ''; // Amount
    this.successUrl = ''; // Add your sucess URL
    this.failureUrl = ''; // Add your failure URL
    this.transactionMode = ''; // Transaction Mode  ( Internet, Moto, or Recurring) Default Value Internet
    this.payModeType = ''; // (CC)-Credit Card, (DC)-Debit Card, (DD)-Direct Debit, (PAYPAL)-PayPal, (NB)-Net Banking . Note: This field is required for ‘Merchant Hosted’ type of integration.
    this.transactionType = ''; // 01 for SALE 02 for AUTHORIZATION
    this.currency = 'SGD'; // AED  Used to specify the currency for the transaction. Currently, only AED is accepted for all transactions (as per ISO Currency Code).

    // Define the Field Existence Indicator for the Billing Data Block , These are optional values
    this.billToFirstName = '';  // 1. BillToFirstName Optional value
    this.billToLastName = '';  // 2. BillToLastName  Optional value
    this.billToStreet1 = '';  // 3. BillToStreet1   Optional value
    this.billToStreet2 = '';  // 4. BillToStreet2   Optional value
    this.billToCity = '';  // 5. BillToCity      Optional value
    this.billToState = '';  // 6. BillToState 	 Optional value
    this.billtoPostalCode = '';  // 7. BillToPostalCode Optional value
    this.billToCountry = '';  // 8. BillToCountry   Optional value
    this.billToEmail = '';  // 9. BillToEmailID   Optional value
    this.billToMobileNumber = '';  // 10. BillToMobileNumber Optional value
    this.billToPhoneNumber1 = '';  // 11. BillToPhoneNumber1 Optional value
    this.billToPhoneNumber2 = '';  // 12. BillToPhoneNumber2 Optional value
    this.billToPhoneNumber3 = '';  // 13. BillToPhoneNumber2 Optional value

    // Define the Field Existence Indicator for the Shipping Data Block , These are optional values
    this.shipToFirstName = ''; // 1. ShipToFirstName Optional value
    this.shipToLastName = ''; // 2. ShipToLastName Optional value
    this.shipToStreet1 = ''; // 3. ShipToStreet1 Optional value
    this.shipToStreet2 = ''; // 4. ShipToStreet2 Optional value
    this.shipToCity = ''; // 5. ShipToCity Optional value
    this.shipToState = ''; // 6. ShipToState Optional value
    this.shipToPostalCode = ''; // 7. ShipToPostalCode Optional value
    this.shipToCountry = ''; // 8. ShipToCountry Optional value
    this.shipToPhoneNumber1 = ''; // 9. ShipToPhoneNumber1 Optional value
    this.shipToPhoneNumber2 = ''; // 10. ShipToPhoneNumber2 Optional value
    this.shipToPhoneNumber3 = ''; // 11. ShipToPhoneNumber3 Optional value
    this.shipToMobileNumber = ''; // 12. ShipToMobileNumber Optional value

    /*
        In case of a credit card transaction, the Payment Data Block formation will be as follows:
            paymentDataBlock = 11111111111|4111111111111111|08|2022|123|Soloman|Visa|9820998209|123456|123456|1026|1202
        In case of a Net Banking transaction, the Payment Data Block formation will be as follows:
            paymentDataBlock = 00000000010|1001 // Here we need Gateway ID
        In case of an IMPS transaction, the Payment Data Block formation will be as follows:
            paymentDataBlock = 00000011100|9820998209|123456|123456	// Here we need Customer Mobile Number, Payment ID , OTP
    */

    this.payModeTypeCard = ['CC', 'DC', 'DD'];
    this.payModeTypeNetBank = ['NB'];

    // Define the Field Existence Indicator for the Payment Data Block , These are optional values
    this.cardNumber = ''; // 1. Card Number
    this.expMonth = ''; // 2. Expiry Month
    this.expYear = ''; // 3. Expiry Year
    this.CVV = ''; // 4. CVV
    this.cardHolderName = ''; // 5. Card Holder Name
    this.cardType = ''; // 6. Card Type
    this.custMobileNumber = ''; // 7. Customer Mobile Number
    this.paymentID = ''; // 8. Payment ID
    this.OTP = ''; // 9. OTP
    this.gatewayID = ''; // 10.Gateway ID
    this.cardToken = ''; // 11.Card Token

    // Define the Field Existence Indicator for the Merchant Data Block , These are optional values
    this.UDF1 = '';  // This is a ‘user-defined field’ that can be used to send additional information about the transaction.
    this.UDF2 = '';  // This is a ‘user-defined field’ that can be used to send additional information about the transaction.
    this.UDF3 = '';  // This is a ‘user-defined field’ that can be used to send additional information about the transaction.
    this.UDF4 = '';  // This is a ‘user-defined field’ that can be used to send additional information about the transaction.
    this.UDF5 = '';  // This is a ‘user-defined field’ that can be used to send additional information about the transaction.
    this.UDF6 = '';  // This is a ‘user-defined field’ that can be used to send additional information about the transaction.
    this.UDF7 = '';  // This is a ‘user-defined field’ that can be used to send additional information about the transaction.
    this.UDF8 = '';  // This is a ‘user-defined field’ that can be used to send additional information about the transaction.
    this.UDF9 = '';  // This is a ‘user-defined field’ that can be used to send additional information about the transaction.
    this.UDF10 = '';  // This is a ‘user-defined field’ that can be used to send additional information about the transaction.

    // Define the Field Existence Indicator for the Other Details Data Block , These are optional values
    this.custID = '';  // The ID used to identify your customer when their profile was created. This field has to be passed by you only if you have opted for the ‘Tokenization/Stored Card’ feature.
    // The field is ‘alphanumeric’; special characters are not allowed.
    this.transactionSource = '';  // This is used to identify a channel, in case you are using multiple channels.
    // Acceptable values are: Web, IVR, or Mobile.
    this.productInfo = '';  // This field is used to send details about the product and related information.
    this.isUserLoggedIn = '';  // Indicates whether a customer has signed in to your website, or has done a Guest checkout Values: ‘Y’ – customer has signed in
    // ‘N’ – customer has done a Guest checkout
    this.itemTotal = '';  // This is a comma-separated list of the sale value of all the items in the order.
    // Example: If the order has two items of value 500 and 1000, send the value as ‘500.00, 1000.00’. Up to 2 decimal places are allowed in the value.
    this.itemCategory = ''; // This is a comma-separated list of the categories of all the items in the order.
    this.ignoreValidationResult = ''; // Indicates whether you want to proceed for Authorization irrespective of the 3DSecure/Authentication result, or not. TRUE/FALSE

    // Define the Field Existence Indicator for the DCC Data Block, These are optional values
    this.DCCReferenceNumber = ''; // DCC Reference Number
    this.foreignAmount = ''; // Foreign Amount
    this.ForeignCurrency = ''; // Foreign Currency

    this.path = 'neologs.txt';

    if (args) {
      for (const [arg_array, val] of Object.entries(args)) {
        // console.log("-----------------------------------------")
        // console.log(args.Network_Online_setting);
        // Set the property for Transaction Array
        if (args.Field_Existence_Indicator_Transaction) {
          this.transactionArray = this.JsonRemoveEmpty(args.Field_Existence_Indicator_Transaction);
        }
        // Set the property for Billing Array
        if (args.Field_Existence_Indicator_Billing) {
          this.billingArray = this.JsonRemoveEmpty(args.Field_Existence_Indicator_Billing);
        }
        // Set the property for Shipping Array
        if (args.Field_Existence_Indicator_Shipping) {
          this.shippingArray = this.JsonRemoveEmpty(args.Field_Existence_Indicator_Shipping);
        }
        // Set the property for Payment Array
        if (args.Field_Existence_Indicator_Payment) {
          this.paymentArray = this.JsonRemoveEmpty(args.Field_Existence_Indicator_Payment);
        }
        // Set the property for Merchant Array
        if (args.Field_Existence_Indicator_Merchant) {
          this.merchantArray = this.JsonRemoveEmpty(args.Field_Existence_Indicator_Merchant);
        }
        // Set the property for Merchant Array
        if (args.Field_Existence_Indicator_OtherData) {
          this.otherDataArray = this.JsonRemoveEmpty(args.Field_Existence_Indicator_OtherData);
        }
        // Set the property for Merchant Array
        if (args.Field_Existence_Indicator_DCC) {
          this.DCCArray = this.JsonRemoveEmpty(args.Field_Existence_Indicator_DCC);
        }


        // Case 0
        // Assiging the property values , This is for Network Online
        if (args.Network_Online_setting) {
          this.InitProp(args.Network_Online_setting);
        }
        /*for (const [key, val] of Object.entries(args.Network_Online_setting)){
            //console.log("+++++++++++++++++++++++++++++++++++++++ :",key)
            if (this.hasOwnProperty(key)){
                //console.log("=================================================================",key)
                this[key] = val;
            }

        }*/
        // Case 1 : <Block Existence Indicator> Bitmap values
        // Assiging the property values for the Block Existence Indicator
        if (args.Block_Existence_Indicator) {
          this.InitProp(args.Block_Existence_Indicator);
        }
        /*for (const [key, val] of Object.entries(args['Block_Existence_Indicator'])){
            if (this.hasOwnProperty(key))
                this[key] = val;
        }*/
        // Case 2 : <Field Existence Indicator for the Block Transaction> Bitmap values
        // Assiging the property values for the Field Existence Indicator for the Block
        if (args.Field_Existence_Indicator_Transaction) {
          this.InitProp(args.Field_Existence_Indicator_Transaction);
        }
        /*for (const [key, val] of Object.entries(args['Field_Existence_Indicator_Transaction'])){
           if (this.hasOwnProperty(key))
               this[key] = val;
       }*/
        // Case 3 : <Field Existence Indicator for the Block Billing> Bitmap values
        // Assiging the property values for the Field Existence Indicator for the Block
        if (args.Field_Existence_Indicator_Billing) {
          this.InitProp(args.Field_Existence_Indicator_Billing);
        }
        /*for (const [key, val] of Object.entries(args['Field_Existence_Indicator_Billing'])){
            if (this.hasOwnProperty(key))
                this[key] = val;
        }*/

        // Case 4 : <Field Existence Indicator for the Block Shipping> Bitmap values
        // Assiging the property values for the Field Existence Indicator for the Block
        if (args.Field_Existence_Indicator_Shipping) {
          this.InitProp(args.Field_Existence_Indicator_Shipping);
        }
        /* for (const [key, val] of Object.entries(args['Field_Existence_Indicator_Shipping'])){
             if (this.hasOwnProperty(key))
                 this[key] = val;
         }*/
        // Case 5 : <Field Existence Indicator for the Block Payment> Bitmap values
        // Assiging the property values for the Field Existence Indicator for the Block
        if (args.Field_Existence_Indicator_Payment) {
          this.InitProp(args.Field_Existence_Indicator_Payment);
        }
        /* for (const [key, val] of Object.entries(args['Field_Existence_Indicator_Payment'])){
             if (this.hasOwnProperty(key))
                 this[key] = val;
         }*/
        // Case 6 : <Field Existence Indicator for the Block Merchant> Bitmap values
        // Assiging the property values for the Field Existence Indicator for the Block
        if (args.Field_Existence_Indicator_Merchant) {
          this.InitProp(args.Field_Existence_Indicator_Merchant);
        }
        /*for (const [key, val] of Object.entries(args['Field_Existence_Indicator_Merchant'])){
            if (this.hasOwnProperty(key))
                this[key] = val;
        }*/
        // Case 7 : <Field Existence Indicator for the Block Other Data> Bitmap values
        // Assiging the property values for the Field Existence Indicator for the Block
        if (args.Field_Existence_Indicator_OtherData) {
          this.InitProp(args.Field_Existence_Indicator_OtherData);
        }
        /*for (const [key, val] of Object.entries(args['Field_Existence_Indicator_OtherData'])){
            if (this.hasOwnProperty(key))
                this[key] = val;
        }*/

        // Case 8 : <Field Existence Indicator for the Block DCC Data> Bitmap values
        // Assiging the property values for the Field Existence Indicator for the Block
        if (args.Field_Existence_Indicator_DCC) {
          this.InitProp(args.Field_Existence_Indicator_DCC);
        }
        /*for (const [key, val] of Object.entries(args['Field_Existence_Indicator_DCC'])){
            if (this.hasOwnProperty(key))
                this[key] = val;
        }*/

        // Check PayMode Type Selected by the Merchant
        if (this.payModeTypeCard.includes(this.payModeType)) {
          // For the Credit Card transaction // (CC)-Credit Card, (DC)-Debit Card, (DD)-Direct Debit
          this.paymentArray = args['Field_Existence_Indicator_Payment'];
          // } elseif (in_array(this.payModeType, this.payModeTypeNetBank)) {
        } else if (this.payModeTypeNetBank.includes(this.payModeType)) {
          // For the (NB)-Net Banking
          this.paymentArray = {'gatewayID': this.gatewayID};
        } else {
          // For IMPS-Hope so (PAYPAL)-PayPal
          this.paymentArray = {
            'custMobileNumber': this.custMobileNumber,
            'paymentID': this.paymentID,
            'OTP': this.OTP
          };
        }

      }
    }
    // Block Existence Indicator Bitmap property
    this.blockExistenceIndicator = this.setblockExistenceIndicator();

    // Transaction Data Block Properties
    this.TransactionFieldExistenceIndicator = this.setTransactionFieldExistenceIndicator();
    // this.TransactionData = this.transactionArray? this.transactionArray.join('|'): null;
    this.TransactionData = this.transactionArray ? this.Json2StrWithSep(this.transactionArray, '|') : null;
    this.TransactionDataBlock1 = this.TransactionFieldExistenceIndicator + '|' + this.TransactionData;

    // Billing Data Block Properties
    this.BillingFieldExistenceIndicator = this.setBillingFieldExistenceIndicator();
    if (this.billingDataBlock) {
      this.BillingData = this.billingArray ? this.Json2StrWithSep(this.billingArray, '|') : null;
      this.BillingDataBlock2 = this.BillingFieldExistenceIndicator + '|' + this.BillingData;
    } else {
      // Replace all the shippingArray Values to NULL and JOIN the Array with pipe delimiter
      const emptybillingArray = [];
      if (this.billingArray) {
        const entries = Object.entries(this.billingArray);
        if (entries) {
          entries.forEach(([prop, val]) => {
            emptybillingArray[prop] = '';
          });
        }

      }

      this.BillingData = emptybillingArray.join('|');
      this.BillingDataBlock2 = this.BillingFieldExistenceIndicator + this.BillingData;
    }
    // Shipping Data Block Properties
    this.ShippingFieldExistenceIndicator = this.setShippingFieldExistenceIndicator();
    if (this.shippingDataBlock) {
      this.ShippingData = this.shippingArray.join('|');
      this.ShippingDataBlock3 = this.ShippingFieldExistenceIndicator + '|' + this.ShippingData;
    } else {
      // Replace all the shippingArray Values to NULL and JOIN the Array with pipe delimiter

      const emptyshippingArray = [];
      if (this.shippingArray) {
        Object.entries(this.shippingArray).forEach(([prop, val]) => {
          emptyshippingArray[prop] = '';
        });
      }

      this.ShippingData = emptyshippingArray.join('|');
      this.ShippingDataBlock3 = this.ShippingFieldExistenceIndicator + this.ShippingData;
    }

    // Payment Data Block Properties
    this.PaymentFieldExistenceIndicator = this.setPaymentFieldExistenceIndicator();
    if (this.paymentDataBlock) {
      const objV = this.paymentArray;
      this.PaymentData = this.Json2Array(objV).join('|');
      this.PaymentDataBlock4 = this.PaymentFieldExistenceIndicator + '|' + this.PaymentData;
    } else {
      // Replace all the shippingArray Values to NULL and JOIN the Array with pipe delimiter
      const emptypaymentArray = [];
      if (this.paymentArray) {
        Object.entries(this.paymentArray).forEach(([prop, val]) => {
          emptypaymentArray[prop] = '';
        });
      }

      this.PaymentData = emptypaymentArray.join('|');
      this.PaymentDataBlock4 = this.PaymentFieldExistenceIndicator + this.PaymentData;
    }
    // Merchant Data Block Properties
    this.MerchantFieldExistenceIndicator = this.setMerchantFieldExistenceIndicator();
    if (this.merchantDataBlock) {
      this.MerchantData = this.merchantArray.join('|');
      this.MerchantDataBlock5 = this.MerchantFieldExistenceIndicator + '|' + this.MerchantData;
    } else {
      // Replace all the merchantArray Values to NULL and JOIN the Array with pipe delimiter
      const emptymerchantArray = [];
      if (this.merchantArray) {
        Object.entries(this.merchantArray).forEach(([prop, val]) => {
          emptymerchantArray[prop] = '';
        });
      }


      this.MerchantData = emptymerchantArray.join('|');
      this.MerchantDataBlock5 = this.MerchantFieldExistenceIndicator + this.MerchantData;
    }

    // Other Data Block Properties
    this.OtherDetailsFieldExistenceIndicator = this.setOtherDetailsFieldExistenceIndicator();
    if (this.otherDataBlock) {
      const objV = this.otherDataArray;
      this.OtherDetailsData = this.Json2StrWithSep(objV, '|');

      // this.OtherDetailsData = this.otherDataBlock? this.otherDataArray.join('|'):'';
      this.OtherDetailsDataBlock6 = this.OtherDetailsFieldExistenceIndicator + '|' + this.OtherDetailsData;
    } else {
      // Replace all the merchantArray Values to NULL and JOIN the Array with pipe delimiter
      const emptyotherDataArray = [];
      if (this.otherDataArray) {
        Object.entries(this.otherDataArray).forEach(([prop, val]) => {
          emptyotherDataArray[prop] = '';
        });
      }
      this.OtherDetailsData = emptyotherDataArray.join('|');
      this.OtherDetailsDataBlock6 = this.OtherDetailsFieldExistenceIndicator + this.OtherDetailsData;
    }
    // DCC Data Block Properties
    this.DCCFieldExistenceIndicator = this.setDCCFieldExistenceIndicator();
    if (this.DCCDataBlock) {
      this.DCCData = this.Json2StrWithSep(this.DCCArray, '|');
      this.DCCDataBlock7 = this.DCCFieldExistenceIndicator + '|' + this.DCCData;
    } else {
      // Replace all the DCCArray Values to NULL and JOIN the Array with pipe delimiter
      const emptyDCCDataArray = [];
      if (this.DCCArray) {
        Object.entries(this.DCCArray).forEach(([prop, val]) => {
          emptyDCCDataArray[prop] = '';
        });
      }

      this.DCCData = emptyDCCDataArray.join('|');
      this.DCCDataBlock7 = this.DCCFieldExistenceIndicator + this.DCCData;
    }
    // Block_Existence_Indicator Bit map and DataBlock`s Array
    this.DataBlocksArray = {
      'DataBlockBitmap': this.blockExistenceIndicator,
      'DataBlock1': this.TransactionDataBlock1,
      'DataBlock2': this.billingDataBlock ? this.BillingDataBlock2 : '',
      'DataBlock3': this.shippingDataBlock ? this.ShippingDataBlock3 : '',
      'DataBlock4': this.paymentDataBlock ? this.PaymentDataBlock4 : '',
      'DataBlock5': this.merchantDataBlock ? this.MerchantDataBlock5 : '',
      'DataBlock6': this.otherDataBlock ? this.OtherDetailsDataBlock6 : '',
      'DataBlock7': this.DCCDataBlock ? this.DCCDataBlock7 : ''
    };
    const obj = this.JsonRemoveEmpty(this.DataBlocksArray);
    /// console.log("this.Json2Array(obj) : ", this.Json2Array(obj))
    // this.beforeEncryptionString =  obj)).join('||');
    this.beforeEncryptionString = this.Json2StrWithSep(obj, '||'); // this.beforeEncryptionString ? this.beforeEncryptionString : '';
    console.log('this.beforeEncryptionString : ', this.beforeEncryptionString);

    /*Object.entries(obj).forEach(([k,v]) =>  {
        if (v !==''){
            this.beforeEncryptionString += v + '||'
        }
    });//  obj)).join('||');*/
    // this.beforeEncryptionString ="1110110||11111111|000000284|37.00|https://www.souqtajmeel.com/networkonlinepayment/nolpay/result/|https://www.souqtajmeel.com/networkonlinepayment/nolpay/result/|INTERNET|CC|01|AED||1110100111000|Abrar|Ahmed|Buheira Corniche|Sharjah|AE|abrar_1979@hotmail.com|0555126110||111010010001|Abrar|Ahmed|Buheira Corniche|Sharjah|AE|0555126110||1000000000|83.110.215.116||1111101|2|Web|English EYELASH ADHESIVE FOR INDIVIDUAL LASHES - CLEAR|Y|15.2400|FALSE ";


    // join('||',array_filter(this.DataBlocksArray));

    this.EncryptedString = this.encryptData(this.beforeEncryptionString, this.merchantKey, this.iv);
    this.NeoPostData = this.merchantId + '||' + this.collaboratorId + '||' + this.EncryptedString;

    const TestNeoPostData = this.merchantId + '||' + this.collaboratorId + '||' + this.EncryptedString;

    // This is puerly for writing logs to check all the values passed to cross check the values passed to NEO
    let requestUrl;
    if (this.url) {
      requestUrl = 'https://NeO.network.ae/direcpay/secure/PaymentTxnServlet';
    } else {
      requestUrl = 'https://uat-NeO.network.ae/direcpay/secure/PaymentTxnServlet';
    }

    const billingDataBlock = this.billingDataBlock ? this.BillingDataBlock2 : 'NULL';
    const shippingDataBlock = this.shippingDataBlock ? this.ShippingDataBlock3 : 'NULL';
    const paymentDataBlock = this.paymentDataBlock ? this.PaymentDataBlock4 : 'NULL';
    const merchantDataBlock = this.merchantDataBlock ? this.MerchantDataBlock5 : 'NULL';
    const otherDataBlock = this.otherDataBlock ? this.OtherDetailsDataBlock6 : 'NULL';
    const DCCDataBlock = this.DCCDataBlock ? this.DCCDataBlock7 : 'NULL';

    // wirte logs before POSTING values

    /*fs.writeFile(this.path, '', (err) => {
      if (err) {
        console.error(err);
        return;
      }
      // file written successfully
    });*/
    this.AddLog('Merchant ID : ' + this.merchantId, 1);
    this.AddLog('Merchant Key : ' + this.merchantKey, 2);
    this.AddLog('Collaborator ID : ' + this.collaboratorId, 3);
    this.AddLog('Neo URL  : ' + requestUrl, 4);
    this.AddLog('Block Existence Indicator   : ' + this.blockExistenceIndicator, 5);
    this.AddLog('DataBlock1 : TransactionDataBlock1   : ' + this.TransactionDataBlock1, 6);
    this.AddLog('DataBlock2 : billingDataBlock   : ' + billingDataBlock, 7);
    this.AddLog('DataBlock3 : shippingDataBlock   : ' + shippingDataBlock, 8);
    this.AddLog('DataBlock4 : paymentDataBlock   : ' + paymentDataBlock, 9);
    this.AddLog('DataBlock5 : merchantDataBlock   : ' + merchantDataBlock, 10);
    this.AddLog('DataBlock6 : otherDataBlock   : ' + otherDataBlock, 11);
    this.AddLog('DataBlock7 : DCCDataBlock   : ' + DCCDataBlock, 12);
    this.AddLog('beforeEncryptionString : ' + this.beforeEncryptionString, 13);
    this.AddLog('EncryptedString  : ' + this.EncryptedString, 14);
    this.AddLog('NeoPostData  : ' + this.NeoPostData, 15);

  }

  JsonRemoveEmpty(obj) {
    Object.entries(obj).forEach(([key, val]) =>
      (val && typeof val === 'object') && this.JsonRemoveEmpty(val) ||
      (val === null || val === '') && delete obj[key]
    );
    return obj;
  }

  Json2StrWithSep(obj, sep) {
    let str = '';
    Object.entries(obj).forEach(([k, v]) => {
      str += v + sep;
    });
    return str.slice(0, -1 * sep.length);
  }

  strip_tags(txt) {
    return txt.replace(/(<([^>]+)>)/ig, '');
  }

  InitProp(obj) {
    for (const [key, val] of Object.entries(obj)) {
      if (this.hasOwnProperty(key)) {
        this[key] = val;
      }
    }
  }

  Json2Array(obj) {
    return Object.keys(obj).map(function (k) {
      return obj[k];
    });
  }

  /** AddLog Function which is used to log the data
   * Function PARAMETERS  : 2
   * global string message Message content which has to be looged
   * global severity severity Log Number
   * returns : logs the content to the logs.txt file
   */
  AddLog(message, severity = 2) {
    console.log(message, severity);
    /* message = this.strip_tags(message);
     message = htmlentities.encode(message);

     fs.appendFile(this.path, '\n' + '[' + severity + ']' + message, (err) => {
       if (err) {
         console.error(err);
       }
       // file written successfully
     });*/
  }


  str_split(string, splitLength = null) {
    if (splitLength === null) {
      splitLength = 1;
    }
    if (string === null || splitLength < 1) {
      return false;
    }
    string += '';
    const asciis = this.stringtoasciis(string);
    // console.log(asciis)
    const chunks = [];
    let pos = 0;
    const len = asciis.length;
    while (pos < len) {
      chunks.push(asciis.slice(pos, pos += splitLength));
    }
    return chunks.map(function (a) {
      return a.map(function (c) {
        return String.fromCharCode(c);
      }).join('');
    });
  }


  codePointToASCIIs(dec) {
    let utf = [];
    if (dec < 0x80) {
      utf = [dec];
    } else if (dec < 0x0800) {
      // tslint:disable-next-line:no-bitwise
      utf = [0xC0 + (dec >> 6)];
      // tslint:disable-next-line:no-bitwise
      utf[1] = 0x80 + (dec & 0x3f);
    } else if (dec < 0x010000) {
      // tslint:disable-next-line:no-bitwise
      utf = [0xE0 + (dec >> 12)];
      // tslint:disable-next-line:no-bitwise
      utf[1] = 0x80 + ((dec >> 6) & 0x3f);
      // tslint:disable-next-line:no-bitwise
      utf[2] = 0x80 + (dec & 0x3f);
    } else if (dec < 0x200000) {
      // tslint:disable-next-line:no-bitwise
      utf = [0xF0 + (dec >> 18)];
      // tslint:disable-next-line:no-bitwise
      utf[1] = 0x80 + ((dec >> 12) & 0x3f);
      // tslint:disable-next-line:no-bitwise
      utf[2] = 0x80 + ((dec >> 6) & 0x3f);
      // tslint:disable-next-line:no-bitwise
      utf[3] = 0x80 + (dec & 0x3f);
    } else {
      return [];
    }
    return utf;
  }

  stringtoasciis(string) {
    let ret = [],
      i = 0;
    while (1) {
      const _ = string.charCodeAt(i++);
      if (isNaN(_)) {
        break;
      }
      const __ = this.codePointToASCIIs(_);
      ret = ret.concat(__);
    }
    return ret;
  }

  array_shift(inputArr) { // eslint-disable-line camelcase
    //  discuss at: https://locutus.io/php/array_shift/
    // original by: Kevin van Zonneveld (https://kvz.io)
    // improved by: Martijn Wieringa
    //      note 1: Currently does not handle objects
    //   example 1: array_shift(['Kevin', 'van', 'Zonneveld'])
    //   returns 1: 'Kevin'
    const _checkToUpIndices = function (arr, ct, key) {
      // Deal with situation, e.g., if encounter index 4 and try
      // to set it to 0, but 0 exists later in loop (need to
      // increment all subsequent (skipping current key, since
      // we need its value below) until find unused)
      if (arr[ct] !== undefined) {
        const tmp = ct;
        ct += 1;
        if (ct === key) {
          ct += 1;
        }
        ct = _checkToUpIndices(arr, ct, key);
        arr[ct] = arr[tmp];
        delete arr[tmp];
      }
      return ct;
    };
    if (inputArr.length === 0) {
      return null;
    }
    if (inputArr.length > 0) {
      return inputArr.shift();
    }
  }

  array_filter(arr, func = null) { // eslint-disable-line camelcase
    //  discuss at: https://locutus.io/php/array_filter/
    // original by: Brett Zamir (https://brett-zamir.me)
    //    input by: max4ever
    // improved by: Brett Zamir (https://brett-zamir.me)
    //      note 1: Takes a function as an argument, not a function's name
    //   example 1: var odd = function (num) {return (num & 1);}
    //   example 1: array_filter({"a": 1, "b": 2, "c": 3, "d": 4, "e": 5}, odd)
    //   returns 1: {"a": 1, "c": 3, "e": 5}
    //   example 2: var even = function (num) {return (!(num & 1));}
    //   example 2: array_filter([6, 7, 8, 9, 10, 11, 12], even)
    //   returns 2: [ 6, , 8, , 10, , 12 ]
    //   example 3: array_filter({"a": 1, "b": false, "c": -1, "d": 0, "e": null, "f":'', "g":undefined})
    //   returns 3: {"a":1, "c":-1}
    let retObj = {};
    let k;
    func = func || function (v) {
      return v;
    };
    // @todo: Issue #73
    if (Object.prototype.toString.call(arr) === '[object Array]') {
      retObj = [];
    }
    for (k in arr) {
      if (func(arr[k])) {
        retObj[k] = arr[k];
      }
    }
    return retObj;
  }


  encryptData(data, key, iv) {
    /* if (process.versions.openssl <= '1.0.1f') {
       throw new Error('OpenSSL Version too old, vulnerability to Heartbleed');
     }*/

    iv = Buffer.from(iv); // crypto.randomBytes(IV_LENGTH);
    // console.log("base64.decode : ",base64.decode(key))
    // let data_php_success = "1101010||11111011|1609053777|1000|http://ipayout.local/payment|http://ipayout.local/payment|INTERNET|01|XOF||1111111111110|Soloman|Vandy|Dubai|Park Street|Mumbai|Maharashtra|400081|IN|solomanv@test.com|9820998209|987|654||00000011100|9820998209|123456|123456||1111111|cust123|IVR|Book|Y|500.00, 1000.00|CD, Book|FALSE"
    // let data_php  = "1101010||11111011|1609053777|1000|http://ipayout.local/payment|http://ipayout.local/payment|INTERNET|01|XOF||1111111111110|Soloman|Vandy|Dubai|Park Street|Mumbai|Maharashtra|400081|IN|solomanv@test.com|9820998209|987|654||00000011100|9820998209|123456|123456||1111111|cust123|IVR|Book|Y|500.00, 1000.00|CD, Book|FALSE"
    // console.log('data_php : ',data_php)
    // data = data_php
    const key_in_bytes = Buffer.from(key, 'base64'); // Buffer.from(key, 'base64')
    iv = aes.utils.utf8.toBytes(iv);
    // 2
    key = key_in_bytes; // aesjs.utils.utf8.toBytes("aaaaaaaaaaaaaaaa");
    // data = data_php
    data = aes.utils.utf8.toBytes(data);

    const aesCbc = new aes.ModeOfOperation.cbc(key, iv);
    const encryptedBytes = aesCbc.encrypt(pkcs7.pad(data));

    const hex = aes.utils.hex.fromBytes(encryptedBytes);
    const buf = Buffer.from(hex, 'hex');
    // console.log("(2) : ",buf.toString('base64'));

    return buf.toString('base64');
  }


  decryptData(data, key, iv) {
    let TransactionResponseValue;
    let result;
    if (data) {
      const merchantId = data.split('||')[0];
      const encryptedPart = data.split('||')[1];
      console.log(merchantId, encryptedPart);
      const key_in_bytes = Buffer.from(key, 'base64');
      iv = aes.utils.utf8.toBytes(iv);
      key = key_in_bytes;
      data = Buffer.from(`${encryptedPart}`, 'base64');

      const aesCbc = new aes.ModeOfOperation.cbc(key, iv);
      const decryptedBytes = aesCbc.decrypt(data);
      // console.log("00000000000000000")
      // console.log("decryptedBytes", decryptedBytes);
      // console.log("00000000000000000")
      const hex = aes.utils.hex.fromBytes(decryptedBytes);
      const buf = Buffer.from(hex, 'hex');
      // console.log("1111111111111")
      // console.log(buf.toString('utf-8'));
      // console.log("1111111111111")
      const decryptedRes = buf.toString('utf-8');

      const responseArray = decryptedRes.split('||');
      // console.log("responseArray : ", responseArray)
      const blockEI = responseArray[0]; // It has to contains Seven indicators
      console.log('blockEI : ', blockEI);
      const bitmapString = this.str_split(blockEI);
      const blockEIArrayKey = [
        'Transaction_Response',               // Same as Request
        'Transaction_related_information',    // Transaction related information
        'Transaction_Status_information',    //  Transaction Status information
        'Merchant_Information',                //   Merchant Information
        'Fraud_Block',                       //    Fraud Block
        'DCC_Block',                      //     DCC Block
        'Additional'                     //      Additional Block Like Card Mask
      ];
      //
      let bit = 0;
      let blockEIArray = {};
      // console.log("bitmapString  : ", bitmapString)
      for (const blockValues of blockEIArrayKey) {
        blockEIArray[blockValues] = bitmapString[bit];
        bit++;
      }
      // console.log("blockEIArray before : ", blockEIArray)
      blockEIArray = this.array_filter(blockEIArray);
      // console.log("blockEIArray after : ", blockEIArray)

      // Remove the first element from Array to map with the bit map values
      responseArray.shift();

      const responseAssignedArray = [];
      let res = 0;
      // Object.keys()
      Object.entries(blockEIArray).forEach(([key, val]) => {
        responseAssignedArray[`${key}`] = responseArray[res];
        // console.log(`responseArray[${res}]`, responseArray[res])
        res++;
      });
      // console.log("responseAssignedArray : ", responseAssignedArray);
      TransactionResponseValue = [];
      TransactionResponseValue['text'] = merchantId + '||' + decryptedRes;
      TransactionResponseValue['merchantId'] = merchantId;
      TransactionResponseValue['DataBlockBitmap'] = blockEI;

      result = {};
      result['text'] = merchantId + '||' + decryptedRes;
      result['merchantId'] = merchantId;
      result['DataBlockBitmap'] = blockEI;

      Object.entries(blockEIArrayKey).forEach(([key, val]) => {
        console.log(key, val);
        if (responseAssignedArray[`${val}`]) {
          TransactionResponseValue[`${val}`] = responseAssignedArray[`${val}`];
          result[`${val}`] = responseAssignedArray[`${val}`];
          // console.log(`TransactionResponseValue[${val}] = ${responseAssignedArray[val]}`)
        } else {
          TransactionResponseValue[`${val}`] = 'NULL';
          result[`${val}`] = 'NULL';
          // console.log(`TransactionResponseValue[${val}] = NULL`)
        }

      });
      // console.log("result", result)
      // return  blockEIArray;
    } else {
      TransactionResponseValue = false;
      result = false;
    }


    return result;
  }


  /**
   * setblockExistenceIndicator Function which is used to return the Block Existence Indicator Bitmap
   * Function PARAMETERS : NULL
   * returns : The Block Existence Indicator Bitmap : String
   */
  setblockExistenceIndicator() {

    let blockExistenceIndicator = '';
    // DataBlock 1 transactionDataBlock
    blockExistenceIndicator += this.transactionDataBlock ? '1' : '0';
    // DataBlock 2 billingDataBlock
    blockExistenceIndicator += this.billingDataBlock ? '1' : '0';
    // DataBlock 3 ShippingDataBlock
    blockExistenceIndicator += this.shippingDataBlock ? '1' : '0';
    // DataBlock 4 PaymentDataBlock
    blockExistenceIndicator += this.paymentDataBlock ? '1' : '0';
    // DataBlock 5 MerchantDataBlock
    blockExistenceIndicator += this.merchantDataBlock ? '1' : '0';
    // DataBlock 6 OtherDataBlock
    blockExistenceIndicator += this.otherDataBlock ? '1' : '0';
    // DataBlock 7 DCCDataBlock
    blockExistenceIndicator += this.DCCDataBlock ? '1' : '0';

    return blockExistenceIndicator;
  }

// Function setTransactionFieldExistenceIndicator Filed Existence Indicator (BEI)
// for Transaction Block Data
  /*
   * setTransactionFieldExistenceIndicator
   * Get all the required property values form the constructor to generate the Bitmap value and the POSTING data
     for the Transaction Block Data, Check if the transactionDataBlock is set to true then generate the Bitmap values
   * @returns Bitmap value for the Transaction Block Data
   *
   */
  setTransactionFieldExistenceIndicator() {

    // Check if the transactionDataBlock is set true
    if (this.transactionDataBlock) {

      let transactionFieldEI = '';
      // Filed 1 Merchant Order Number For Transaction Data Block 1
      transactionFieldEI += this.merchantOrderNumber ? '1' : '0';
      // Filed 2 Amount For Transaction Data Block 1
      transactionFieldEI += this.amount ? '1' : '0';
      // Filed 3 SuccessUrl For Transaction Data Block 1
      transactionFieldEI += this.successUrl ? '1' : '0';
      // Filed 4 FailureUrl For Transaction Data Block 1
      transactionFieldEI += this.failureUrl ? '1' : '0';
      // Filed 5 TransactionMode For Transaction Data Block 1
      transactionFieldEI += this.transactionMode ? '1' : '0';
      // Filed 6 PayModeType For Transaction Data Block 1
      transactionFieldEI += this.payModeType ? '1' : '0';
      // Filed 7 TransactionType For Transaction Data Block 1
      transactionFieldEI += this.transactionType ? '1' : '0';
      // Filed 8 Currency For Transaction Data Block 1
      transactionFieldEI += this.currency ? '1' : '0';

      return transactionFieldEI;
    } else {
      return '00000000';
    }

  }

// Function setBillingFieldExistenceIndicator Filed Existence Indicator (BEI)
// for Billing Block Data
  /*
   * setBillingFieldExistenceIndicator
   * Get all the required property values form the constructor to generate the Bitmap value
     for the Billing Block Data, Check if the billingDataBlock is set to true then generate the Bitmap values
   * @returns Bitmap value for the Billing Block Data
   *
   */
  setBillingFieldExistenceIndicator() {

    if (this.billingDataBlock) {

      let billingFieldEI = '';
      // Filed 1 BillTo FirstName For Billing Data Block 2
      billingFieldEI += this.billToFirstName ? '1' : '0';
      // Filed 2 BillTo billToLastName For Billing Data Block 2
      billingFieldEI += this.billToLastName ? '1' : '0';
      // Filed 3 BillTo billToStreet1 For Billing Data Block 2
      billingFieldEI += this.billToStreet1 ? '1' : '0';
      // Filed 4 BillTo billToStreet2 For Billing Data Block 2
      billingFieldEI += this.billToStreet2 ? '1' : '0';
      // Filed 5 BillTo billToCity For Billing Data Block 2
      billingFieldEI += this.billToCity ? '1' : '0';
      // Filed 6 BillTo billToState For Billing Data Block 2
      billingFieldEI += this.billToState ? '1' : '0';
      // Filed 7 BillTo billtoPostalCode For Billing Data Block 2
      billingFieldEI += this.billtoPostalCode ? '1' : '0';
      // Filed 8 BillTo billToCountry For Billing Data Block 2
      billingFieldEI += this.billToCountry ? '1' : '0';
      // Filed 9 BillTo billToEmail For Billing Data Block 2
      billingFieldEI += this.billToEmail ? '1' : '0';
      // Filed 10 BillTo billToMobileNumber For Billing Data Block 2
      billingFieldEI += this.billToMobileNumber ? '1' : '0';
      // Filed 11 BillTo billToPhoneNumber1 For Billing Data Block 2
      billingFieldEI += this.billToPhoneNumber1 ? '1' : '0';
      // Filed 12 BillTo billToPhoneNumber2 For Billing Data Block 2
      billingFieldEI += this.billToPhoneNumber2 ? '1' : '0';
      // Filed 13 BillTo billToPhoneNumber3 For Billing Data Block 2
      billingFieldEI += this.billToPhoneNumber3 ? '1' : '0';

      return billingFieldEI;
    } else {
      return '0000000000000';
    }
  }

// Function setShippingFieldExistenceIndicator Filed Existence Indicator (BEI)
// for Shipping Block Data
  /*
   * setShippingFieldExistenceIndicator
   * Get all the required property values form the constructor to generate the Bitmap value
     for the Shipping Block Data, Check if the shippingDataBlock is set to true then generate the Bitmap values
   * @returns Bitmap value for the Shipping Block Data
   *
   */
  setShippingFieldExistenceIndicator() {

    if (this.shippingDataBlock) {

      let shippingFieldEI = '';
      // Filed 1 shipToFirstName For Shipping Data Block 3
      shippingFieldEI += this.shipToFirstName ? '1' : '0';
      // Filed 2 shipToLastName For Shipping Data Block 3
      shippingFieldEI += this.shipToLastName ? '1' : '0';
      // Filed 3 shipToStreet1 For Shipping Data Block 3
      shippingFieldEI += this.shipToStreet1 ? '1' : '0';
      // Filed 4 shipToStreet2 For Shipping Data Block 3
      shippingFieldEI += this.shipToStreet2 ? '1' : '0';
      // Filed 5 shipToCity For Shipping Data Block 3
      shippingFieldEI += this.shipToCity ? '1' : '0';
      // Filed 6 shipToState For Shipping Data Block 3
      shippingFieldEI += this.shipToState ? '1' : '0';
      // Filed 7 shipToPostalCode For Shipping Data Block 3
      shippingFieldEI += this.shipToPostalCode ? '1' : '0';
      // Filed 8 shipToCountry For Shipping Data Block 3
      shippingFieldEI += this.shipToCountry ? '1' : '0';
      // Filed 9 shipToPhoneNumber1 For Shipping Data Block 3
      shippingFieldEI += this.shipToPhoneNumber1 ? '1' : '0';
      // Filed 10 shipToPhoneNumber2 For Shipping Data Block 3
      shippingFieldEI += this.shipToPhoneNumber2 ? '1' : '0';
      // Filed 11 shipToPhoneNumber3 For Shipping Data Block 3
      shippingFieldEI += this.shipToPhoneNumber3 ? '1' : '0';
      // Filed 12 shipToMobileNumber For Shipping Data Block 3
      shippingFieldEI += this.shipToMobileNumber ? '1' : '0';

      return shippingFieldEI;

    } else {
      return '000000000000';
    }

  }

  in_array(needle, haystack, argStrict = null) { // eslint-disable-line camelcase
    //  discuss at: https://locutus.io/php/in_array/
    // original by: Kevin van Zonneveld (https://kvz.io)
    // improved by: vlado houba
    // improved by: Jonas Sciangula Street (Joni2Back)
    //    input by: Billy
    // bugfixed by: Brett Zamir (https://brett-zamir.me)
    //   example 1: in_array('van', ['Kevin', 'van', 'Zonneveld'])
    //   returns 1: true
    //   example 2: in_array('vlado', {0: 'Kevin', vlado: 'van', 1: 'Zonneveld'})
    //   returns 2: false
    //   example 3: in_array(1, ['1', '2', '3'])
    //   example 3: in_array(1, ['1', '2', '3'], false)
    //   returns 3: true
    //   returns 3: true
    //   example 4: in_array(1, ['1', '2', '3'], true)
    //   returns 4: false
    let key = '';
    const strict = !!argStrict;
    // we prevent the double check (strict && arr[key] === ndl) || (!strict && arr[key] === ndl)
    // in just one for, in order to improve the performance
    // deciding wich type of comparation will do before walk array
    if (strict) {
      for (key in haystack) {
        if (haystack[key] === needle) {
          return true;
        }
      }
    } else {
      for (key in haystack) {
        if (haystack[key] === needle) { // eslint-disable-line eqeqeq
          return true;
        }
      }
    }
    return false;
  }

// Function setPaymentFieldExistenceIndicator Filed Existence Indicator (BEI)
// for Payment Block Data
  /*
   * setPaymentFieldExistenceIndicator
   * Get all the required property values form the constructor to generate the Bitmap value
     for the Payment Block Data, Check if the paymentDataBlock is set to true then generate the Bitmap values
   * @returns Bitmap value for the Payment Block Data
   *
   */
  setPaymentFieldExistenceIndicator() {
    let paymentFieldEI = '';
    if (this.paymentDataBlock) {

      // Here we are having three options
      // 1 ) Credit Card transaction // (CC)-Credit Card, (DC)-Debit Card, (DD)-Direct Debit // BitMap : 11111111111
      // 2 ) (NB)-Net Banking // BitMap : 00000000010
      // 3 ) IMPS-Hope so (PAYPAL)-PayPal //  BitMap : 00000011100

      const creditArray = ['CC', 'DC', 'DD'];

      if (this.in_array(this.payModeType, creditArray)) {

        // Filed 1 cardNumber For Payment Data Block 4
        paymentFieldEI += this.cardNumber ? '1' : '0';
        // Filed 2 expMonth For Payment Data Block 4
        paymentFieldEI += this.expMonth ? '1' : '0';
        // Filed 3 expYear For Payment Data Block 4
        paymentFieldEI += this.expYear ? '1' : '0';
        // Filed 4 CVV For Payment Data Block 4
        paymentFieldEI += this.CVV ? '1' : '0';
        // Filed 5 cardHolderName For Payment Data Block 4
        paymentFieldEI += this.cardHolderName ? '1' : '0';
        // Filed 6 cardType For Payment Data Block 4
        paymentFieldEI += this.cardType ? '1' : '0';
        // Filed 7 custMobileNumber For Payment Data Block 4
        paymentFieldEI += this.custMobileNumber ? '1' : '0';
        // Filed 8 paymentID For Payment Data Block 4
        paymentFieldEI += this.paymentID ? '1' : '0';
        // Filed 9 OTP For Payment Data Block 4
        paymentFieldEI += this.OTP ? '1' : '0';
        // Filed 10 gatewayID For Payment Data Block 4
        paymentFieldEI += this.gatewayID ? '1' : '0';
        // Filed 11 cardToken For Payment Data Block 4
        paymentFieldEI += this.cardToken ? '1' : '0';

        return paymentFieldEI;

      } else if (this.payModeType === 'NB') {
        paymentFieldEI = '00000000010';
        return paymentFieldEI;
      } else {
        paymentFieldEI = '00000011100';
        return paymentFieldEI;
      }
    } else {
      paymentFieldEI = '00000000000';
      return paymentFieldEI;
    }
  }

// Function setMerchantFieldExistenceIndicator Filed Existence Indicator (BEI)
// for Merchant Block Data
  /*
   * setMerchantFieldExistenceIndicator
   * Get all the required property values form the constructor to generate the Bitmap value
     for the Merchant Block Data, Check if the merchantDataBlock is set to true then generate the Bitmap values
   * @returns Bitmap value for the Merchant Block Data
   *
   */
  setMerchantFieldExistenceIndicator() {

    if (this.merchantDataBlock) {
      let merchantFieldEI = '';
      // Filed 1 UDF1 For Merchant Data Block 5
      merchantFieldEI += this.UDF1 ? '1' : '0';
      // Filed 2 UDF2 For Merchant Data Block 5
      merchantFieldEI += this.UDF2 ? '1' : '0';
      // Filed 3 UDF3 For Merchant Data Block 5
      merchantFieldEI += this.UDF3 ? '1' : '0';
      // Filed 4 UDF4 For Merchant Data Block 5
      merchantFieldEI += this.UDF4 ? '1' : '0';
      // Filed 5 UDF5 For Merchant Data Block 5
      merchantFieldEI += this.UDF5 ? '1' : '0';
      // Filed 6 UDF6 For Merchant Data Block 5
      merchantFieldEI += this.UDF6 ? '1' : '0';
      // Filed 7 UDF7 For Merchant Data Block 5
      merchantFieldEI += this.UDF7 ? '1' : '0';
      // Filed 8 UDF8 For Merchant Data Block 5
      merchantFieldEI += this.UDF8 ? '1' : '0';
      // Filed 9 UDF9 For Merchant Data Block 5
      merchantFieldEI += this.UDF9 ? '1' : '0';
      // Filed 10 UDF10 For Merchant Data Block 5
      merchantFieldEI += this.UDF10 ? '1' : '0';

      return merchantFieldEI;

    } else {
      return '0000000000';
    }

  }

// Function setOtherDetailsFieldExistenceIndicator Filed Existence Indicator (BEI)
// for Other Details Block Data
  /*
   * setOtherDetailsFieldExistenceIndicator
   * Get all the required property values form the constructor to generate the Bitmap value
     for the Other Details Block Data, Check if the otherDataBlock is set to true then generate the Bitmap values
   * @returns Bitmap value for the Other Details Block Data
   *
   */
  setOtherDetailsFieldExistenceIndicator() {

    if (this.otherDataBlock) {

      let otherFieldEI = '';
      // Filed 1 custID For OtherDeatils Data Block 6
      otherFieldEI += this.custID ? '1' : '0';
      // Filed 2 transactionSource For OtherDeatils Data Block 6
      otherFieldEI += this.transactionSource ? '1' : '0';
      // Filed 3 productInfo For OtherDeatils Data Block 6
      otherFieldEI += this.productInfo ? '1' : '0';
      // Filed 4 isUserLoggedIn For OtherDeatils Data Block 6
      otherFieldEI += this.isUserLoggedIn ? '1' : '0';
      // Filed 5 itemTotal For OtherDeatils Data Block 6
      otherFieldEI += this.itemTotal ? '1' : '0';
      // Filed 6 itemCategory For OtherDeatils Data Block 6
      otherFieldEI += this.itemCategory ? '1' : '0';
      // Filed 7 ignoreValidationResult For OtherDeatils Data Block 6
      otherFieldEI += this.ignoreValidationResult ? '1' : '0';

      return otherFieldEI;

    } else {
      return '0000000';
    }
  }

// Function setDCCFieldExistenceIndicator Filed Existence Indicator (BEI)
// for DCC Block Data
  /*
   * setDCCFieldExistenceIndicator
   * Get all the required property values form the constructor to generate the Bitmap value
     for the DCC Block Data, Check if the DCCDataBlock is set to true then generate the Bitmap values
   * @returns Bitmap value for the DCC Block Data
   *
   */
  setDCCFieldExistenceIndicator() {

    if (this.DCCDataBlock) {
      let DCCFieldEI = '';
      // Filed 1 DCCReferenceNumber For DCC Data Block 7
      DCCFieldEI += this.DCCReferenceNumber ? '1' : '0';
      // Filed 1 foreignAmount For DCC Data Block 7
      DCCFieldEI += this.foreignAmount ? '1' : '0';
      // Filed 1 ForeignCurrency For DCC Data Block 7
      DCCFieldEI += this.ForeignCurrency ? '1' : '0';

      return DCCFieldEI;

    } else {
      return '000';
    }

  }

}
